// extracted by mini-css-extract-plugin
export default {"container":"LogisticsScreen_container__z2ENX"};